import { getUserData } from '../../shared/info-device';
import { 
    getRequestAbsencePermissionsAdmin,
    sendNewAbsencePermissions,
    sendUpdateAbsencePermissions
} from '../../shared/data-services/employee-services';
import { ResetTvRounded } from '@mui/icons-material';

export async function getAbsencePermissionsAdmin(filters){
   
    //console.log(filters)
    const data = await getRequestAbsencePermissionsAdmin(filters);
    return data;
};

export async function saveNewAbsencePermissions(dataForm){
    const data = await sendNewAbsencePermissions(dataForm);
    return data.data;
};

export async function editAbsencePermissions(dataForm){
    //console.log('dataForm :>> ', dataForm);
    const data = await sendUpdateAbsencePermissions(dataForm);
    //console.log('data :>> ', data);
    return data;
};

/*
export async function getSegmentType(){
    const data = await getSegmentTypes();
    return data;
};

export async function saveNewSegment(dataForm){
    //const { employeeId: user } = getUser();
    //const { userdata: { ip } } = await getUserData();
    //const userAgent = navigator.userAgent;

    //const params = {...dataForm, ...addons};
    const data = await sendNewSegment(dataForm);
    return data;
};

export async function deleteSegment(segmentId){
    const { employeeId: user } = getUser();
    const { userdata: { ip } } = await getUserData();
    const userAgent = navigator.userAgent;

    const params = { segmentId, userAgent, user, ip }
    const data = await sendDeleteSegment(params);
    return data;
};
*/